export default "__VITE_ASSET__4ddf08f1__"